export default __webpack_public_path__ + "static/media/nft1.c759f772.jpg";